// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__12soZ","container":"styles_container__1wA4-","title":"styles_title__1Jm01","wrapper":"styles_wrapper__14kb7","answer":"styles_answer__343rR"};